export interface SystemTaskRegistration {
  systemTaskId: string;
  /** To whom the task is assigned. Either UserId or AssignmentGroupId needs to be specified. */
  userId: string;
  /**  To whom the task is assigned. Either UserId or AssignmentGroupId needs to be specified. */
  assignmentGroupId: string;
  /** Here you can track the final consumer of the result of the task.
   * For example if user A (RelatedUserId) files a task to user B (UserId) once user B completes the task then user A can be informed of the task completition.
   * Meanwhile User A can track in which status the task is.
   */
  relatedUserId: string;
  parameters: any[];
  descriptionParameters: any[];
  urlParameters: any[];
}
